import axios from 'axios';

const OPS_TOKEN_KEY = 'ops_token';

const opsApi = axios.create({
  baseURL: '/api/ops',
  headers: { 'Content-Type': 'application/json' },
});

opsApi.interceptors.request.use((config) => {
  const token = sessionStorage.getItem(OPS_TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getOpsToken = () => sessionStorage.getItem(OPS_TOKEN_KEY);
export const setOpsToken = (token: string) => sessionStorage.setItem(OPS_TOKEN_KEY, token);
export const clearOpsToken = () => sessionStorage.removeItem(OPS_TOKEN_KEY);

export default opsApi;
